// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3XkNk","footer":"Form_footer__7kkPT"};